module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAAAjHyAjHyAjHyAjHyAjHyAjHyAjHyCo06W8AAAAB3RSTlMAYL8AIM/vi50ITwAAAFlJREFUeF7t1qEZgDAUA+HMgKlGMUDKBHxMADugQfStzwYkDpPT/wAHYKrPZhLcS3QS/VJobFhLdqBpdGPR6EEZ/YSCgoKCgoKCgqyhsdbImixr17zxI/VCvmJHrBVlhqdbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2b1b.png
// module id = 1420
// module chunks = 0